import React from 'react';
import PropTypes from 'prop-types';

import CalendarIcon from '../../../../assets/calendar.svg';
import InputComponent from '../InputComponent';

const inputStyles = {
  borderBottomColor: '#0C1B1E',
  borderRadius: 0,
  padding: '10px 12px',
  position: 'absolute',
};

const DatePicker = React.forwardRef(({
  value, onClick, name, inputLabel,
}) => (
  <InputComponent
    label={inputLabel}
    placeholder=""
    onClick={onClick}
    value={value}
    extraStyles={{ marginRight: '16px', width: '145px' }}
    style={inputStyles}
    name={name}
    icon={<CalendarIcon onClick={onClick} />}
  />
));

DatePicker.propTypes = {
  value: PropTypes.oneOfType([Date]).isRequired,
  name: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  inputLabel: PropTypes.string.isRequired,
};

export default DatePicker;
